import React from "react";
import ProfileInfo from "../Components/Profile/ProfileInfo";
import ProfileUpdate from "../Components/Profile/ProfileUpdate";

function Profile() {
  return (
    <>
      <ProfileInfo />
      <ProfileUpdate />
    </>
  );
}

export default Profile;
